import React, { Component } from 'react';
import   { TextField as Text } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Button, DatePicker, Card, CardText, CardTitle, DataTable, DialogContainer, 
    Grid, TableBody, TableColumn, TableHeader, TableRow, TextField, Toolbar } from 'react-md';

import { Pedido } from '../models/Pedido';

import Message from '../components/message';
import Breadcrumb from '../components/Breadcrumb';
import { clearDigitsSpecialChars } from '../common/parsers';
import { css } from '../styles/print.css';
import { formatCurrency, itemIdFormater, formatQuantidade, datePickerFormatter } from '../common/formaters'
import { openSnackbar } from '../components/message';
import Api from '../common/api';


const TODAY = new Date();
let count = 0;
export default class Pedidos extends Component {
 
    constructor(props) {
        super(props);

        this.state = {
            itens: [],
            itemIndex: "",
            visible: false,
            value: "",
            counter: 0,
        };

    }

    componentDidMount() {
        this.getAll();
        this.actions = [{
            label: 'Imprimir',
            primary: true,
            onClick: this.print,
        }, {
            label: 'Fechar',
            secondary: true,
            onClick: this.hideConfirm,
        }];
    }

    render() {
        const { visible, criado, printVisible, model, comprador, pageX, pageY, counter } = this.props;
        const { itens, name, itemIndex, value,  newItemDisabled } = this.state;
        const defaultProps = {
            freeSolo: true,
            options: itens,
            getOptionLabel: (option) => option.id_item ? `${itemIdFormater(option.id_item)} - ${option.nome}` : null,
        };

        this.state.counter = this.props.counter;

        return (
            <DialogContainer id="modal-form" visible={visible} pageX={pageX} pageY={pageY}
                fullPage onHide={this.hide} aria-labelledby="modal-form-title">
                    <form onSubmit={this.handleSave}>
                    <Toolbar fixed colored title="Pedido" titleId="modal-form-title" 
                        nav={<Button icon onClick={this.hide}>close</Button>}/>
                    <Grid>
                        <Card tableCard className="md-cell md-cell--12 tw-card">
                            <CardTitle title="Pedido"/>
                            <CardText className="floating" > 
                                <h2 style={{padding:"0 0 0 1%", margin:"0"}}>{this.props.comprador.nome}</h2>
                                <div style={{margin:"0"}} className="buttons__group">
                                    <div style={{padding:"3% 0 0 1%"}} className="left-group">
                                        <h2 style={{margin:"0", fontSize:"large"}}>Pedido: {this.props.model.id ? this.props.model.id : this.props.pedidos_id}</h2>
                                    </div>
                                    <div style={{margin:"0 50% 0 0"}} className="right-group">
                                        <DatePicker id="date-picker-auto-ok" label="Selecione a data"
                                        autoOk className="md-text--secondary" defaultValue={model.criado ? datePickerFormatter(model.criado) : TODAY}
                                        onChange={this.handleChangeData}/>
                                    </div>
                                </div>
                            </CardText>
                            <DataTable baseId="pedidos-list" className="tw-table no-padding" plain={true} responsive>
                                <TableHeader>
                                <TableRow>
                                    <TableColumn style={{padding:"0"}}>Quantidade</TableColumn>
                                    <TableColumn>Item</TableColumn>
                                    <TableColumn>Custo</TableColumn>
                                    <TableColumn>Valor Un.</TableColumn>
                                    <TableColumn>Total</TableColumn>
                                    <TableColumn>Lucro</TableColumn>
                                    <TableColumn></TableColumn>
                                </TableRow>
                                </TableHeader>
                                <TableBody>
                                   {
                                    this.props.model.itens.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableColumn style={{width:"9%"}}> 
                                                <TextField id="quantidade" lineDirection="center" value={formatQuantidade(item.quantidade)}
                                                    className="md-cell md-cell--12" onChange={this.handleChangeQuantidade(index)}
                                                    error={false} required/>
                                            </TableColumn>
                                            <TableColumn style={{width:"40%"}}>

                                                <Autocomplete
                                                    {...defaultProps}
                                                    id="controlled-demo"
                                                    className="md-cell md-cell--12"
                                                    defaultValue={item}
                                                    onInputChange={( event, value) => this.handleInput(value, index)}
                                                    onChange={( event, value ) => this.handleAutocomplete(value, index)}
                                                    renderInput={(params) => <Text {...params}/>}
                                                />

                                            </TableColumn>
                                            <TableColumn style={{width:"11%"}}>
                                                <TextField id="custo_unitario" lineDirection="center" value={formatCurrency(item.custo_unitario)}
                                                    className="md-cell md-cell--12" onChange={this.handleChange(index, 'custo_unitario')}
                                                    error={false} required/>
                                            </TableColumn>
                                            <TableColumn style={{width:"11%"}}>
                                                <TextField id="valor_unitario" lineDirection="center" value={formatCurrency(item.valor_unitario)}  onKeyPress={this.handleKeyEnter}
                                                    className="md-cell md-cell--12" onChange={this.handleChange(index, 'valor_unitario')}
                                                    error={false} required/>
                                            </TableColumn>
                                            <TableColumn style={{width:"11%"}}>
                                                <TextField id="total" lineDirection="center" value={formatCurrency(item.total)} disabled
                                                    className="md-cell md-cell--12" onChange={this.handleChange(index, 'total')}/>
                                            </TableColumn>
                                            <TableColumn style={{width:"11%"}}>
                                                <TextField id="lucro" lineDirection="center" value={formatCurrency(item.lucro)} disabled
                                                    className="md-cell md-cell--12" onChange={this.handleChange(index, 'lucro')}/>
                                            </TableColumn>
                                            <TableColumn style={{width:"7%", padding:"0"}}>
                                                { this.props.model.itens.length > 1 ? 
                                                    <Button icon primary onClick={this.onRemove(index)}>delete</Button> : null
                                                }
                                                { this.props.model.itens.length === index + 1 ? 
                                                    <Button icon primary onClick={this.handleAddClick(item)}>add</Button> : null
                                                }
                                            </TableColumn>
                                        </TableRow>
                                    ))} 
                                </TableBody>
                            </DataTable>
                            <CardText>
                                <TextField id="observacao" placeholder="Digite as observações sobre o pedido" rows={2} 
                                    onChange={this.handleChangeObservacao} className="md-cell md-cell--12" value={this.props.model.observacao}/>
                            </CardText>
                            <div style={{display:"flex", width:"50%", position:"relative", float:"right", padding:"0px 16px"}}>
                                <div style={{flex:"1"}} className="md-cell--left md-cell--12 md-text-right">
                                    <h4>Lucro Total: <b>{formatCurrency(this.calcLucro())}</b></h4>
                                </div>
                                <div style={{flex:"1"}} className="md-cell--left md-cell--12 md-text-right">
                                    <h4>Total pedido: <b>{formatCurrency(this.calcTotal())}</b></h4>
                                </div>
                            </div>
                            <div className="buttons__group">
                                <Button type="submit" raised className="btn btn-primary" iconChildren="check">
                                    Finalizar
                                </Button>
                            </div>
                        </Card>
                        <DialogContainer 
                            title="Pedido" visible={printVisible} onHide={this.hideConfirm}
                            actions={this.actions} height={'auto'} width={'90%'}>
                            <Card id="pedido-dialog" tableCard className="md-cell md-cell--12 tw-card">
                                <div>
                                    <h4><b>{this.props.comprador.nome}</b></h4>
                                    <p><b>Pedido: {this.props.model.id ? this.props.model.id : this.props.pedidos_id}</b></p>
                                    <p><b>{model.criado}</b></p>
                                    <p>{model.observacao}</p>
                                    <DataTable baseId="confirmation-pedido-table" fullWidth={true} 
                                        className="data-tables__edit-table-example tw-table" plain={true}>
                                        <TableHeader>
                                            <TableRow>
                                                <TableColumn style={{padding:"0"}}>Quantidade</TableColumn>
                                                <TableColumn>Item</TableColumn>
                                                <TableColumn className="button">Custo Un.</TableColumn>
                                                <TableColumn>Valor Un.</TableColumn>
                                                <TableColumn>Total</TableColumn>
                                                <TableColumn className="button">Lucro</TableColumn>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody >
                                            {this.props.model.itens.map((item, index) => (
                                                <TableRow key={index} style={index % 2 === 0 ? {background: "#eee", border: "3px solid", borderColor: "gray"} : {background: "white", border: "3px solid", borderColor: "gray"}}>
                                                    <TableColumn className="td-background">
                                                        <div className="div-background-value">{formatQuantidade(item.quantidade)}</div>
                                                    </TableColumn>
                                                    <TableColumn className="td-background">
                                                        <div className="div-background-name">{item.nome}</div>
                                                    </TableColumn>
                                                    <TableColumn className="button">{formatCurrency(item.custo_unitario)}</TableColumn>
                                                    <TableColumn className="td-background">
                                                        <div className="div-background-value">{formatCurrency(item.valor_unitario)}</div>
                                                    </TableColumn>
                                                    <TableColumn className="td-background">
                                                        <div className="div-background-value">{formatCurrency(item.total)}</div>
                                                    </TableColumn>
                                                    <TableColumn className="button">{formatCurrency(item.lucro)}</TableColumn>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </DataTable>
                                    <div className="md-cell--left md-cell--12 md-text-right">
                                        <div className="tw-simple-price" style={{display:"flex", width:"50%", position:"relative", float:"right"}}>
                                            <div style={{flex:"1"}}>
                                                <h4 className="tw-simple-price button">Lucro Total: <b>{formatCurrency(this.calcLucro())}</b></h4>
                                            </div>
                                            <div style={{flex:"1"}}>
                                                <h4 className="tw-simple-price">Total pedido: <b>{formatCurrency(this.calcTotal())}</b></h4>
                                            </div>
                                        </div>
                                        <h4 className="tw-simple-price button">Saldo anterior: <b>{formatCurrency(this.props.saldo_anterior)}</b></h4>
                                        <h4><span className="tw-alert-price">Saldo devedor: <b>{formatCurrency(this.props.saldo_devedor)}</b></span></h4>
                                    </div>
                                </div>
                            </Card>
                        </DialogContainer>
                        <Message />
                    </Grid>
                    </form>
            </DialogContainer>
        );
    }
    getAll = () => {
        Api.getTodosItens()
        .then(response => response.json())
        .then(itens => this.setState({itens: itens.map(item => {
            item.custo_unitario = formatCurrency(item.custo_unitario);
            item.id_item = item.id;
            return item;
        })}))
        .catch(error => openSnackbar({ message: error }));
    }
    
    hideConfirm = () => {
        this.setState({ visible: false });
        this.hide();
    };

    hide = () => {
        count = 0;
        this.props.onHide();
    }

    print = () => {
        Api.print(css, 'pedido-dialog');
        this.hideConfirm();
    }

    handleChangeQuantidade = (index) => value => {

        const re = /^\d+(.\d+)*$/;
        let newValue = this.props.model.itens[index].quantidade;

        if (value === '' || re.test(value)) {
            newValue = value;
        }
        let pedido = this.props.model;
        let item = pedido.itens[index];
        item.quantidade = clearDigitsSpecialChars(newValue);
        pedido.itens[index] = this.calcItem(item);
        this.props.onChange(pedido);
    }

    handleCustoChange = (index) => value => {
        
        let pedido = this.props.model;

        if (value) {
            pedido.itens[index].custo_unitario = clearDigitsSpecialChars(value);
        }

        setTimeout(() => {
            this.props.onChange(pedido);
        });

    };

    handleAutocomplete = async (value, index) => {
        let pedido = this.props.model;

        pedido.itens[index].nome = '';
        pedido.itens[index].id_item = '';
        pedido.itens[index].custo_unitario = '';

        if (value) {
            await Api.getItemLastPrice(this.props.comprador.id, value.id_item)
            .then(response => response.json())
            .then(price => price[0] ? pedido.itens[index].valor_unitario = clearDigitsSpecialChars(price[0].valor_unitario) : '');

            pedido.itens[index].nome = value.nome;
            pedido.itens[index].id_item = value.id_item;
            pedido.itens[index].custo_unitario = clearDigitsSpecialChars(value.custo_unitario);
        }

        setTimeout(() => {
            this.props.onChange(pedido);
        });
    };

    handleInput = (value, index) => {
        let pedido = this.props.model;

        count += 1;

        if(this.state.counter < count) {
            pedido.itens[index].nome = '';
            pedido.itens[index].id_item = '';
            pedido.itens[index].custo_unitario = '';
            
            if (value) {
                pedido.itens[index].nome = value;
            }
        }

        setTimeout(() => {
            this.props.onChange(pedido);
        });
    };

    handleChangeObservacao = value => {
        let pedido = this.props.model;
        pedido.observacao = value;
        this.props.onChange(pedido);
    }

    handleChangeData = value => {
        let pedido = this.props.model;
        pedido.criado = value;
        this.props.onChange(pedido);
    }

    handleChange = (index, name) => value => {
        let pedido = this.props.model;
        let item = pedido.itens[index];
        item[name] = value;
        pedido.itens[index] = this.calcItem(item);;
        this.props.onChange(pedido);
    }

    addNew = () => {
        let pedido = this.props.model;
        pedido.itens.push({
            sugestoes: []
        });
        this.setState({pedido});
    }

    handleKeyEnter = (event) => {
        if (event.key === 'Enter') {
            this.addNew();
        }
    }

    handleAddClick = item => event => {
        if(!item.quantidade || !item.nome) return;
        this.addNew();
    }

    catchError = error => {
        openSnackbar({ message: error });
        this.props.history.push('/pedidos/lista');
    }

    beforeSave = (model) => {
        
        let itens = model.itens.map(item => {
            item.custo_unitario = clearDigitsSpecialChars(item.custo_unitario);
            item.valor_unitario = clearDigitsSpecialChars(item.valor_unitario);
            return item;
        })
        model.itens = itens;
        this.setState({model});
    }

    handleSave = event => {
        event.preventDefault();
        let entrou = false;

        this.props.model.itens.map((item) => {
            if(item.nome == null || item.nome == undefined || item.nome == "") {
            openSnackbar({ message: 'Item não selecionado' });    
            return entrou = true; 
            }
        });

        if(!entrou){
            let model = new Pedido(this.props.model);

            this.beforeSave(model)
            model.id_comprador = this.props.comprador.id;

            setTimeout(() => {
                this.props.onSave(model);
            });
        }
    }

    onRemove = index => value => {
        let pedido = this.props.model;
        pedido.itens.splice(index, 1);
        this.setState({pedido});
    }


    calcItem = item => {
        item.valor_unitario = clearDigitsSpecialChars(item.valor_unitario ? item.valor_unitario : 0);
        item.custo_unitario = clearDigitsSpecialChars(item.custo_unitario ? item.custo_unitario : 0);

        if(item.quantidade && item.valor_unitario && item.custo_unitario){
            item.total = item.quantidade * item.valor_unitario;
            item.lucro = item.total - (item.quantidade * item.custo_unitario);
            item.total = item.total;
        }
        item.valor_unitario = item.valor_unitario ? item.valor_unitario : 0;
        item.custo_unitario = item.custo_unitario ? item.custo_unitario : 0;
        return item;
    }

    calcTotal = () => {
        let itens = this.props.model.itens;
        let total = 0;
        itens.forEach(item => {
            if(item.total)
                total += parseInt(clearDigitsSpecialChars(item.total), 10)
        });
        return total;
    }

    calcLucro = () => {
        let itens = this.props.model.itens;
        let lucro = 0;
        itens.forEach(item => {
            if(item.lucro)
            lucro += parseInt(item.lucro, 10)
        });
        return lucro;
    }
}




// WEBPACK FOOTER //
// ./src/forms/PedidoForm.js